import styled from 'styled-components';
import { theme } from '_constants/theme';
const { colors, devices, fontSizes, spaces } = theme;

const StyledSearchTrademarkGeniusSection = styled.div`
  max-width: 1400px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding-top: 100px;
  h1 {
    font-family: 'MontserratBold';
    font-style: normal;
    font-size: ${fontSizes.large}px;
    line-height: 130%;
    text-align: center;
    color: #394149;
  }
  p {
    font-family: 'MontserratRegular';
    font-style: normal;
    font-size: ${fontSizes.regular}px;
    line-height: 130%;
    text-align: center;
    color: #03589c;
    padding-left: 100px;
    padding-right: 100px;
  }
  @media ${devices.tablet} {
    padding-top: 20px;
    padding-left: 16px;
    padding-right: 16px;
    p {
      padding-left: 0px;
      padding-right: 0px;
    }
  }
`;

const SearchTrademarkGeniusSection = () => {
  return (
    <StyledSearchTrademarkGeniusSection>
      <h1>At TradeMark Genius</h1>
      <p>
        We've simplified the trademark application process to empower your
        business's journey. Once you've engaged in thorough searches through the
        USPTO database, kick-start your application by completing a
        comprehensive questionnaire about your business. Rest assured, all the
        information you provide is safeguarded, ensuring your privacy and
        security.
      </p>
      <p>
        With your part done, it's time for us to take the reins. Our team of
        trademark application experts will meticulously review the details
        you've furnished. Drawing on our expertise, we'll identify any missing
        information and conduct an exhaustive search to maximize the chances of
        success for your application.
      </p>
      <p>
        When it comes to filing, we've got you covered. We'll electronically
        submit your application to the USPTO, streamlining the process and
        minimizing the administrative burden on you. Embarking on the trademark
        application journey with TradeMark Genius is a strategic move that not
        only safeguards your brand's identity but also positions you as a
        distinct entity in your industry. With a comprehensive trademark search
        process and a user-friendly application procedure, TradeMark Genius
        equips you with the tools you need to navigate the complex world of
        intellectual property protection with confidence.
      </p>
    </StyledSearchTrademarkGeniusSection>
  );
};

export default SearchTrademarkGeniusSection;
